var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21814_6299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7143 0H5.28571C2.3665 0 0 2.3665 0 5.28572V18.7143C0 21.6335 2.3665 24 5.28571 24H18.7143C21.6335 24 24 21.6335 24 18.7143V5.28572C24 2.3665 21.6335 0 18.7143 0Z",
    fill: "url(#paint0_linear_21814_6299)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 4C9.87827 4.00002 7.84345 4.78402 6.34316 6.17955C4.84287 7.57508 4.00001 9.46782 4 11.4414C4.00193 12.7251 4.36085 13.9865 5.04187 15.1031C5.72289 16.2196 6.70285 17.1533 7.88651 17.8133C7.57125 18.6015 7.09844 19.3406 6.48764 20C7.67212 19.7678 8.78402 19.28 9.73679 18.5746C10.4714 18.7776 11.2336 18.8814 12 18.8828C14.1217 18.8828 16.1566 18.0988 17.6568 16.7033C19.1571 15.3077 20 13.415 20 11.4414C20 9.46782 19.1571 7.57508 17.6568 6.17955C16.1566 4.78402 14.1217 4.00002 12 4Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_21814_6299",
    x1: 12.1905,
    y1: 22.4069,
    x2: 12.1905,
    y2: 2.97851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CBD2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BF675"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21814_6299"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsIcon);
export default __webpack_public_path__ + "static/media/sms-icon.43c48d176e7a88c1e7f9e2a049c750d0.svg";
export { ForwardRef as ReactComponent };